import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

interface IconsProps {
    icon: IconProp;
}

const Icons: React.FC<IconsProps> = ({ icon }) => {
    return (
        <div>
            <FontAwesomeIcon icon={icon} />
        </div>
    );
};

export default Icons;